import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Outlet } from "react-router-dom";
import ToastProvider from "@/contexts/Toast/ToastProvider";
import { GlobalStyle, LayoutBackground } from "@enxcs/dap-ui-stratos";
import HeaderSmartDebrief from "@/components/Header";
import { CustomLayoutContainer } from "../App.styles";
import { AppModalProvider } from "@/contexts/AppModal/AppModalProvider";
import FooterSmartDebrief from "@/components/Footer";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ResponsiveGridStyled } from "./styles";
import { IndexDBProvider } from "@/contexts/IndexDB/IndexDBProvider";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";
import GenericError from "@/components/GenericError";
import { RecordingStatusProvider } from "@/contexts/RecordingStatus/RecordingStatusProvider";
import { BlockerProvider } from "@/contexts/Blocker/BlockerProvider";
import { InternetStatusProvider } from "@/contexts/InternetStatus/InternetStatusProvider";
import { retryPendingRecordingDeletions } from "@/utils/deleteCurrentRecording";
import { cleanupLegacyRecordingLocalStorage } from "@/storage/recording";
export default function LayoutWithProviders() {
  const queryClient = useQueryClient();

  // See docs/recording-upload-retry.md.
  useEffect(() => {
    retryPendingRecordingDeletions(() => queryClient.invalidateQueries({ queryKey: ["recordingSubjects"] }));
    cleanupLegacyRecordingLocalStorage();
  }, [queryClient]);

  return (
    <AppErrorBoundary fallback={<GenericError />}>
      <ToastProvider>
        <GlobalStyle base={"/"} />
        <HeaderSmartDebrief />
        <LayoutBackground id={"layout-container"}>
          <CustomLayoutContainer>
            <ResponsiveGridStyled>
              <IndexDBProvider>
                <AppModalProvider>
                  <RecordingStatusProvider>
                    <InternetStatusProvider>
                      <BlockerProvider>
                        <Outlet />
                      </BlockerProvider>
                    </InternetStatusProvider>
                  </RecordingStatusProvider>
                </AppModalProvider>
              </IndexDBProvider>
            </ResponsiveGridStyled>
          </CustomLayoutContainer>
        </LayoutBackground>
        <FooterSmartDebrief />
      </ToastProvider>
      <ReactQueryDevtools initialIsOpen={import.meta.env.DEV ? true : false} />
    </AppErrorBoundary>
  );
}
